import { useLocale } from '@/i18n/LocaleProvider';
import { isLocaleCode, selectableLocales } from '@/i18n/dictionary';
import styles from './AvatarMenu.module.css';

/** `<select>` из `i18n.selectableLocales` (README «Avatar menu»). */
export function LanguageSelect() {
  const { lang, setLang, t } = useLocale();
  return (
    <select
      className={styles.select}
      value={lang}
      aria-label={t('menu.language')}
      onChange={(event) => {
        const next = event.target.value;
        if (isLocaleCode(next)) setLang(next);
      }}
    >
      {selectableLocales.map((locale) => (
        <option key={locale.code} value={locale.code}>
          {locale.label}
        </option>
      ))}
    </select>
  );
}
